import citizen_contract from '../../../../build/contracts/Citizens.json'
import democracy_contract from '../../../../build/contracts/Democracy.json'
import token_contract from '../../../../build/contracts/Token.json'
import store from '../../../store'

const contract = require('truffle-contract')

export const IS_CITIZEN = 'IS_CITIZEN'
function cityUpdated(city) {
    return {
        type: IS_CITIZEN,
        payload: city
    }
}

export function getCity(address) {
  
    let web3 = store.getState().web3.web3Instance

    if (typeof web3 !== 'undefined') {

        return function(dispatch) {
 
            let cInstance
            let id = 'N-N'
            let citizenName = 'N-N'
            let citizenSince = 'N-N'
            let citizensNum = 'N-N'
            let budget = 'N-N'
            let proposalsNum = 'N-N'
            let balanceIn ='N-N'
            let balanceInToken = 'N-N'

            
            const DemocracyContract = contract(democracy_contract)
            DemocracyContract.setProvider(web3.currentProvider)

            const CitizenContract = contract(citizen_contract)
            CitizenContract.setProvider(web3.currentProvider)

            const TokenContract = contract(token_contract)
            TokenContract.setProvider(web3.currentProvider)

			
            CitizenContract.deployed().then((contractInstance) => {
                cInstance = contractInstance	
			
                return cInstance.memberId(address)
            }).then((result) => {
			
                id = result.toString()
                return cInstance.numCitizens()
            }).then((result) => {
			
                citizensNum = result.toString()
                return cInstance.members(id)
            }).then((result) => {
			
                citizenName = result[1]
                citizenSince = result[2].toString()
			
                DemocracyContract.deployed().then((contractInstance) => {
                    cInstance = contractInstance	
				
                    return cInstance.numProposals()
                }).then((result) => {
				
                    proposalsNum = result.toString()
                    return cInstance.amountRaised()
                }).then((result) => {
				
                    let money = parseFloat(web3.fromWei(result.toString()));
                    budget = money + " ETH"
                    return cInstance.balanceOf(address)
                }).then((result) => {
				
                    let paid = parseFloat(web3.fromWei(result.toString()));
                    balanceIn = paid + " ETH"
				
                    TokenContract.deployed().then((contractInstance) => {
                        cInstance = contractInstance	
					
                        return cInstance.balanceOf(address)
                    }).then((result) => {
					
                        let token = parseFloat(web3.fromWei(result.toString()));
                        balanceInToken = token + " ETH"

                        return dispatch(cityUpdated({'memberId':id,'citizenName':citizenName,'citizenSince':citizenSince,'citizensNum':citizensNum,'budget':budget,'proposalsNum':proposalsNum,'balanceIn':balanceIn,'balanceInToken':balanceInToken}))


                    })
				
                })
			
            })
		
        }
    } else {
        console.error('Web3 is not initialized.');
    }
}



// WEBPACK FOOTER //
// ./src/user/actions/city/GetCity.js